import { type AxiosInstance } from "axios";
import * as Sentry from "@sentry/react";
import { type GetDataTransferResponse } from "@/features/salesforceIntegration/types";
import { DATA_TRANSFERS_ENDPOINT } from "@/features/salesforceIntegration/api/postDataTransfer";
import { getDataTransferResponseSchema } from "@/features/salesforceIntegration/schemas/transferEligibility";

/**
 * 連携ジョブの状況を取得する（`GET /salesforce/data-transfers/{transferId}/`）。
 * 5秒間隔のポーリングで呼び出す（`hooks/useSalesforceDataTransfer.ts`）。
 *
 * `status`がポーリングの停止条件のため、実行時に契約を検証する。
 * 想定外の値のまま進めるとポーリングが止まらない。
 */
export const getDataTransfer = async (
  apiClient: AxiosInstance,
  transferId: number
): Promise<GetDataTransferResponse> => {
  const url = `${DATA_TRANSFERS_ENDPOINT}${transferId}/`;
  const { data } = await apiClient.get<unknown>(url);

  const parsed = getDataTransferResponseSchema.safeParse(data);
  if (!parsed.success) {
    const error = new Error(`API contract violation at ${url}`);
    Sentry.captureException(error, { extra: { issues: parsed.error.issues } });
    throw error;
  }

  return parsed.data;
};
